import { useEffect } from "react";
import "./RedirectionPage.css";
import { Container } from "react-bootstrap";

function RedirectionPage(props) {
  useEffect(() => {
    setTimeout(function () {
      window.location.href = "https://d2epc.iti.gr/";
    }, 1000);
  }, []);
  return (
    <Container id="redirectionPage">
      <h1 id="redirectionTitle">Unauthorized</h1>
      <p>You are about to be redirected to the login page.</p>
    </Container>
  );
}

export default RedirectionPage;
